import DashboardLayout from '../../layouts/LayoutContainers/DashboardLayout'
import CreateSubjectTabs from './components/CreateSubjectContent/CreateSubjectTabs'
import useCreateSubject from './useCreateSubject'
import CreateSubjectContent from './components/CreateSubjectContent'

const CreateSubject = () => {
  const {
    handleChange,
    activeTab,
    addGrid,
    availableGrids,
    grids,
    isLoading,
    difficultyFilters,
    handleSelectDifficulty,
    filteredTags,
    setFilteredCorrect,
    setFilteredTags,
    filteredCorrect,
    closeModal,
    filtersPopupOpened,
    setFiltersPopupOpened,
    setDifficultyFilters,
    handleSearchValue,
    searchedValue,
    subject,
    onSuccessCreateSubject,
    removeGrid,
    handleChangeChaptersByCourse,
    allSources,
    selectedSource,
    handleChangeSource,
    grileTypes,
    handleChangeGrileTypes,
  } = useCreateSubject()
  return (
    <DashboardLayout>
      <div className="flex  ml-auto mr-auto transition-all duration-700 ease-in-out">
        <div
          className={`ml-auto mr-auto ${
            activeTab === 0 ? 'max-w-[800px]' : ''
          } relative w-full`}
        >
          <div className="flex justify-center">
            <div className="max-w-[800px] flex-grow">
              <CreateSubjectTabs
                handleChange={handleChange}
                activeTab={activeTab}
              />
            </div>
          </div>
          <div className="w-full">
            <div>
              <CreateSubjectContent
                handleChangeGrileTypes={handleChangeGrileTypes}
                grileTypes={grileTypes}
                handleChangeSource={handleChangeSource}
                selectedSource={selectedSource}
                sources={allSources}
                handleChangeChaptersByCourse={handleChangeChaptersByCourse}
                removeGrid={removeGrid}
                onSuccessCreateSubject={onSuccessCreateSubject}
                subject={subject}
                handleSearchValue={handleSearchValue}
                searchedValue={searchedValue}
                difficultyFilters={difficultyFilters}
                handleSelectDifficulty={handleSelectDifficulty}
                filteredTags={filteredTags}
                setFilteredCorrect={setFilteredCorrect}
                setFilteredTags={setFilteredTags}
                filteredCorrect={filteredCorrect}
                closeModal={closeModal}
                filtersPopupOpened={filtersPopupOpened}
                isLoading={isLoading}
                availableGrids={availableGrids}
                grids={grids}
                addGrid={addGrid}
                activeTab={activeTab}
                setFiltersPopupOpened={setFiltersPopupOpened}
                setDifficultyFilters={setDifficultyFilters}
              />
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  )
}

export default CreateSubject
